import React, { Component } from 'react';
import './css/Modal.css';

class Modal extends Component {
  render() {
    const { show, onClose, children } = this.props;
    if (!show) return null;

    return (
      <div className="modal-backdrop">
        <div className="modal-box">
          <button className="close-btn" onClick={onClose}>×</button>
          <div className="modal-content">{children}</div>
        </div>
      </div>
    );
  }
}

export default Modal;
